import axiosInstance from "../axiosClient";
import { userCreation, userList, userStatus, userUpdate } from "../config";



export const getUsers = async (name,limit, start_key,email ,id) => {
  let queryParams = [];
  if (limit) queryParams.push(`limit=${encodeURIComponent(limit)}`)
  if (name) queryParams.push(`name=${encodeURIComponent(name)}`);
  if (start_key) queryParams.push(`start_key=${encodeURIComponent(start_key)}`);
  if (email) queryParams.push(`email=${encodeURIComponent(email)}`);
  if (id) queryParams.push(`id=${encodeURIComponent(id)}`);

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return await axiosInstance.get(`${userList}${queryString}`);
};

export const createUser = async (data) => {
  return await axiosInstance.post(userCreation,data);
};

export const update_User=  async(data) => {
  return await axiosInstance.patch(userUpdate,data);
};

export const handleuserStatus= async (data) => {
  return await axiosInstance.patch(userStatus, data);
};



